import React from 'react';
import ProgressTrendChart from '../../../pages/user-profile-dashboard/components/ProgressTrendChart';

const ProgressTrendCard = ({
  trendMode,
  setTrendMode,
  trendYear,
  setTrendYear,
  availableTrendYears,
  weeklyTabs,
  trendWeekIndex,
  setTrendWeekIndex,
  monthlyTrendDataByYear,
  weeklyTrendData,
}) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4 md:mb-6">
        <div className="text-lg md:text-xl font-heading font-semibold text-foreground">진행 추이</div>
        <div className="flex items-center gap-2 flex-wrap">
          <button
            type="button"
            onClick={() => setTrendMode('monthly')}
            className={`px-3 py-2 rounded-md text-sm font-medium transition-gaming ${
              trendMode === 'monthly'
                ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                : 'bg-muted/40 text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            월별
          </button>
          <button
            type="button"
            onClick={() => setTrendMode('weekly')}
            className={`px-3 py-2 rounded-md text-sm font-medium transition-gaming ${
              trendMode === 'weekly'
                ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                : 'bg-muted/40 text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            주별
          </button>

          {trendMode === 'monthly' ? (
            <select
              value={trendYear}
              onChange={(e) => setTrendYear(Number(e.target.value))}
              className="ml-2 px-3 py-2 rounded-md bg-muted/40 border border-border text-sm text-foreground"
              aria-label="진행추이 년도 선택"
            >
              {(availableTrendYears || []).map((y) => (
                <option key={y} value={y}>
                  {y}년
                </option>
              ))}
            </select>
          ) : null}
        </div>
      </div>

      {trendMode === 'weekly' ? (
        <div className="mb-4 overflow-x-auto">
          <div className="flex items-center gap-2 min-w-max">
            {(weeklyTabs?.tabs || []).map((w) => (
              <button
                key={w}
                type="button"
                onClick={() => setTrendWeekIndex(w)}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-gaming ${
                  trendWeekIndex === w
                    ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                    : 'bg-muted/40 text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
              >
                {w}주차
              </button>
            ))}
          </div>
        </div>
      ) : null}

      {trendMode === 'monthly' ? (
        <ProgressTrendChart
          data={monthlyTrendDataByYear}
          embedded
          xKey="month"
          lineKey="proofs"
          lineName="증명 제출"
        />
      ) : (
        <ProgressTrendChart
          data={weeklyTrendData}
          embedded
          xKey="day"
          lineKey="proofs"
          lineName="증명 제출"
        />
      )}
    </div>
  );
};

export default ProgressTrendCard;
